import { DashboardIcon } from "../icons/DashboardIcon"
import { AboutIcon } from "../icons/AboutIcon"
import { PerformanceIcon } from "../icons/PerformanceIcon"
import { TabList, Tab } from "react-tabs"
// import { logEvent } from "../utils/logEvent"

// not set as FC on purpose, workaround for react-tabs error
export const renderAppTabList = (isMobile: boolean) => {
  return isMobile ? (
    <TabList>
      <Tab
      // onClick={() => logEvent("DemoAppTabClick", { tab: "DASHBOARD" })}
      >
        <div className="absolute top-1/2 -translate-y-1/2 w-full flex flex-col items-center justify-center">
          <DashboardIcon />
          <span className="mt-2 text-xs">DASHBOARD</span>
        </div>
      </Tab>

      <Tab
      // onClick={() => logEvent("DemoAppTabClick", { tab: "PERFORMANCE" })}
      >
        <div className="absolute top-1/2 -translate-y-1/2 w-full flex flex-col items-center justify-center">
          <PerformanceIcon />
          <span className="mt-2 text-xs">PERFORMANCE</span>
        </div>
      </Tab>

      <Tab
      // onClick={() => logEvent("DemoAppTabClick", { tab: "ABOUT" })}
      >
        <div className="absolute top-1/2 -translate-y-1/2 w-full flex flex-col items-center justify-center">
          <AboutIcon />
          <span className="mt-2 text-xs">ABOUT</span>
        </div>
      </Tab>
    </TabList>
  ) : (
    <TabList className="h-full w-1/2 absolute left-1/2 -translate-x-1/2 z-20 flex justify-center space-x-6 text-tab font-semibold">
      <Tab
        className="focus:outline-none w-fit h-full relative list-none cursor-pointer text-slate-300 flex items-center"
        selectedClassName="!text-black"
        // onClick={() => logEvent("DemoAppTabClick", { tab: "DASHBOARD" })}
      >
        <DashboardIcon className="w-5 h-5" />
        <span className="ml-1">DASHBOARD</span>
      </Tab>

      <Tab
        className="focus:outline-none w-fit h-full relative list-none cursor-pointer text-slate-300 flex items-center"
        selectedClassName="!text-black"
        // onClick={() => logEvent("DemoAppTabClick", { tab: "PERFORMANCE" })}
      >
        <PerformanceIcon className="w-5 h-5" />
        <span className="ml-1">PERFORMANCE</span>
      </Tab>

      <Tab
        className="focus:outline-none w-fit h-full relative list-none cursor-pointer text-slate-300 flex items-center"
        selectedClassName="!text-black"
        // onClick={() => logEvent("DemoAppTabClick", { tab: "ABOUT" })}
      >
        <AboutIcon className="w-6 h-6" />
        <span className="ml-1">ABOUT</span>
      </Tab>
    </TabList>
  )
}

